import { useTheme } from '../../hooks/useTheme';

import AccountHeader from './AccountHeader';
import AccountMenuItems from './AccountMenuItems';
import { NAV_THEMES } from './nav-tokens';
import type { AppModeInfo } from './use-app-mode';

interface NavPanelAccountProps {
  viewer: AppModeInfo;
}

/** The panel is always on screen, so unlike the popover and the drawer it has
 *  nothing to dismiss when a row navigates. */
const NO_DISMISS = () => {};

/** Who you are, at the foot of the labelled panel —
 *  the rows that used to sit behind the top bar's avatar. The icon-only panel
 *  has no room for them and hides this block; Sign out is pinned below it
 *  either way. */
export default function NavPanelAccount({ viewer }: NavPanelAccountProps) {
  const { theme } = useTheme();
  const t = NAV_THEMES[theme];
  return (
    <div
      data-testid="nav-panel-account"
      className="pt-2"
      style={{ borderTop: `1px solid ${t.border}` }}
    >
      <div
        className="px-4 text-[11px] font-bold uppercase tracking-wider"
        style={{ color: t.muted }}
      >
        Account
      </div>
      <AccountHeader viewer={viewer} />
      <AccountMenuItems onNavigate={NO_DISMISS} />
    </div>
  );
}
